<placeme-layout-seo [seo]="'clientsPage.seo' | translate">
  <placeme-jumbotron [seo]="'clientsPage.seo' | translate"></placeme-jumbotron>

  <section class="main-content">
    <div class="clients-shapes">
      <div class="circle"></div>
      <div class="circle"></div>
    </div>
    <div class="clients">
      <markdown class="page-markdown" [data]="'clientsPage.clients.content' | translate"></markdown>
      <ul class="clients__container">
        <li class="clients__container__item" *ngFor="let item of 'clientsPage.clients.clients' | translate">
          <a target="_blank" [href]="item.website">
            <img [src]="item.seo.image.url" [alt]="item.seo.title" [title]="item.seo.title" />
          </a>
        </li>
      </ul>
    </div>
  </section>

  <section class="testimonials-section">
    <div class="testimonials">
      <markdown class="page-markdown blue-white" [data]="'clientsPage.testimonials.content' | translate"></markdown>
      <swiper-container class="light" [slidesPerView]="slidesPerView" spaceBetween="50" pagination="true" pagination-clickable="true">
        <swiper-slide *ngFor="let item of 'clientsPage.testimonials.testimonials' | translate">
          <blockquote class="testimonial">
            <div class="testimonial__headerContainer">
              <div class="testimonial__headerContainer__avatar">
                <img [src]="item?.avatar?.url" [alt]="item?.name" [title]="item?.name" />
              </div>
              <div class="testimonial__headerContainer__header">
                <h3 class="testimonial__headerContainer__header__name">{{ item?.name }}</h3>
                <p class="testimonial__headerContainer__header__job">{{ item?.job }}</p>
              </div>
            </div>
            <p class="testimonial__text">{{ item?.comment }}</p>
          </blockquote>
        </swiper-slide>
      </swiper-container>
    </div>
  </section>

  <section class="main-content">
    <div class="partners">
      <markdown class="page-markdown" [data]="'clientsPage.partners.content' | translate"></markdown>
      <ul class="partners__container">
        <li class="partners__container__item" *ngFor="let item of 'clientsPage.partners.partners' | translate">
          <a target="_blank" [href]="item.website">
            <img [src]="item.seo.image.url" [alt]="item.seo.title" [title]="item.seo.title" />
          </a>
        </li>
      </ul>
    </div>
  </section>
</placeme-layout-seo>
